import Cookies from 'js-cookie'
import { useCallback } from 'react'

import { SaveUserApiArg } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_SAVE_USER_SERVER } from '@/app/module/user/definitions'
import { getUser } from '@/app/module/user/store/actions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useSaveUser = () => {
  const dispatch = useAppDispatch()
  const [mutate, res] = esApi.endpoints.saveUser.useMutation()

  const save = useCallback(
    async (body: SaveUserApiArg['body']) => {
      try {
        await mutate({ body }).unwrap()

        dispatch(
          createNotification({
            'save-user': {
              type: 'success',
              message: 'Profile updated successfully.',
            },
          }),
        )

        const token = Cookies.get('authToken') || ''
        if (token) {
          await dispatch(getUser({ token }))
        }

        return true
      } catch (error) {
        dispatch(
          createNotification({
            'save-user': {
              type: 'error',
              message: getErrorMessage(error, ERROR_SAVE_USER_SERVER),
            },
          }),
        )
        return false
      }
    },
    [dispatch, mutate],
  )

  return [save, res] as const
}
